import React from 'react'

import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js'
import { Pie } from 'react-chartjs-2'
import Colors from 'utils/Colors'

import styles from './styles'

ChartJS.register(ArcElement, Tooltip, Legend)

const PieChart = (props) => {
  const { data, labels, title, colors } = props
  const classes = styles()
  
  const graphData = {
    labels: labels,
    datasets: [
      {
        label: 'Aplicações',
        data: data,
        backgroundColor: colors,
        borderColor: Colors.white,
        borderWidth: 2,
      },
    ],
  }
  return (
    <div className={classes.container}>
      <h4 className={classes.title}>{title}</h4>
      <div className={classes.graphContainer}>
        <div className={classes.graphWrapper}>
          <Pie data={graphData} />
        </div>
      </div>
    </div>
  )
}



export default PieChart
